export default __webpack_public_path__ + "static/area_9-c6b051cb028b8e57e3e240d0849c423c.jpg";